var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMatenimiento2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 214,
    height: 214,
    viewBox: "0 0 214 214",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6741",
    "data-name": "Rectangle 6741",
    width: 214,
    height: 214,
    transform: "translate(-9 -9)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6740",
    "data-name": "Rectangle 6740",
    width: 192.426,
    height: 193.099,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6724",
    "data-name": "Rectangle 6724",
    width: 16.29,
    height: 1.503,
    transform: "translate(119.912 123.117)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-4"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6723",
    "data-name": "Rectangle 6723",
    width: 16.29,
    height: 1.5,
    transform: "translate(119.912 123.117)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-5"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6726",
    "data-name": "Rectangle 6726",
    width: 16.29,
    height: 1.5,
    transform: "translate(119.912 152.967)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-7"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6728",
    "data-name": "Rectangle 6728",
    width: 16.29,
    height: 1.502,
    transform: "translate(119.912 142.276)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-8"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6727",
    "data-name": "Rectangle 6727",
    width: 16.29,
    height: 1.5,
    transform: "translate(119.912 142.277)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-9"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6730",
    "data-name": "Rectangle 6730",
    width: 16.29,
    height: 1.501,
    transform: "translate(119.912 132.347)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-10"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6729",
    "data-name": "Rectangle 6729",
    width: 16.29,
    height: 1.5,
    transform: "translate(119.912 132.347)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-11"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6732",
    "data-name": "Rectangle 6732",
    width: 16.29,
    height: 1.503,
    transform: "translate(58.623 123.117)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-12"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6731",
    "data-name": "Rectangle 6731",
    width: 16.29,
    height: 1.5,
    transform: "translate(58.623 123.117)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-13"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6734",
    "data-name": "Rectangle 6734",
    width: 16.29,
    height: 1.5,
    transform: "translate(58.623 152.967)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-15"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6736",
    "data-name": "Rectangle 6736",
    width: 16.29,
    height: 1.502,
    transform: "translate(58.623 142.276)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-16"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6735",
    "data-name": "Rectangle 6735",
    width: 16.29,
    height: 1.5,
    transform: "translate(58.623 142.277)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-17"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6738",
    "data-name": "Rectangle 6738",
    width: 16.29,
    height: 1.501,
    transform: "translate(58.623 132.347)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-18"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6737",
    "data-name": "Rectangle 6737",
    width: 16.29,
    height: 1.5,
    transform: "translate(58.623 132.347)",
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_2",
    "data-name": 2,
    transform: "translate(9 9)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8779",
    "data-name": "Group 8779",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8778",
    "data-name": "Group 8778"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8777",
    "data-name": "Group 8777",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_22863",
    "data-name": "Path 22863",
    d: "M138.382,57.409V110.8a4.537,4.537,0,0,1-4.531,4.532H60.337a4.537,4.537,0,0,1-4.532-4.532V57.409",
    fill: "#009cdd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22864",
    "data-name": "Path 22864",
    d: "M29.848,153.968H171.875L136.2,181.83,96.84,185.518h-23L43.059,172.286Z",
    fill: "#464545"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6719",
    "data-name": "Rectangle 6719",
    width: 20.585,
    height: 23.493,
    transform: "translate(56.471 138.519)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6720",
    "data-name": "Rectangle 6720",
    width: 20.585,
    height: 20.976,
    transform: "translate(117.257 141.036)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6721",
    "data-name": "Rectangle 6721",
    width: 12.265,
    height: 18.5,
    transform: "translate(74 9.663)",
    fill: "#464545"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22865",
    "data-name": "Path 22865",
    d: "M97.733,98.858a6.659,6.659,0,0,1-6.651-6.652V60.916a6.652,6.652,0,1,1,13.3,0v31.29a6.659,6.659,0,0,1-6.652,6.652m0-44.174A6.239,6.239,0,0,0,91.5,60.916v31.29a6.231,6.231,0,1,0,12.463,0V60.916a6.239,6.239,0,0,0-6.232-6.232",
    fill: "#040405"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22866",
    "data-name": "Path 22866",
    d: "M97.733,99.092a6.894,6.894,0,0,1-6.887-6.885V60.917a6.887,6.887,0,1,1,13.774,0v31.29a6.893,6.893,0,0,1-6.887,6.885",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6722",
    "data-name": "Rectangle 6722",
    width: 12.11,
    height: 4.033,
    transform: "translate(74.078 28.115)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22867",
    "data-name": "Path 22867",
    d: "M86.422,32.383H73.845v-4.5H86.422ZM74.31,31.914H85.956V28.35H74.31Z",
    fill: "#040405"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22868",
    "data-name": "Path 22868",
    d: "M86.369,32.46H73.9V27.8H86.369Zm-12.11-.624H86.008V28.427H74.259Z",
    fill: "#040405"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22869",
    "data-name": "Path 22869",
    d: "M86.6,32.695H73.664V27.569H86.6ZM74.492,31.6H85.774v-2.94H74.492Z",
    fill: "#464545"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22870",
    "data-name": "Path 22870",
    d: "M93.439,142.547v-8.055h7.311v8.048l-.587-.528a4.647,4.647,0,0,0-6.137.008Zm.7-7.352v5.841a5.334,5.334,0,0,1,5.9-.007V135.2Z",
    fill: "#464545"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22871",
    "data-name": "Path 22871",
    d: "M97.1,150.737a5.292,5.292,0,0,1-3.545-9.24l.471.522a4.542,4.542,0,0,0-1.534,3.406,4.607,4.607,0,1,0,9.214,0,4.538,4.538,0,0,0-1.543-3.413l.471-.524a5.293,5.293,0,0,1-3.534,9.249",
    fill: "#464545"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22872",
    "data-name": "Path 22872",
    d: "M97.07,149.308a3.882,3.882,0,1,1,3.883-3.883,3.888,3.888,0,0,1-3.883,3.883m0-7.491a3.609,3.609,0,1,0,3.609,3.608,3.615,3.615,0,0,0-3.609-3.608",
    fill: "#464545"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22873",
    "data-name": "Path 22873",
    d: "M100.836,134.849H93.361V133.1h7.475Zm-7.195-.28h6.914v-1.19H93.641Z",
    fill: "#464545"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22874",
    "data-name": "Path 22874",
    d: "M138.545,162.715H116.554V115.424h21.991Zm-21.288-.7h20.585V116.128H117.257Z",
    fill: "#464545"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_8741",
    "data-name": "Group 8741",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8740",
    "data-name": "Group 8740"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8739",
    "data-name": "Group 8739",
    clipPath: "url(#clip-path-3)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8738",
    "data-name": "Group 8738"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8737",
    "data-name": "Group 8737",
    clipPath: "url(#clip-path-4)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_22875",
    "data-name": "Path 22875",
    d: "M135.686,124.621H120.427a.516.516,0,0,1-.515-.516v-.468a.515.515,0,0,1,.515-.515h15.259a.515.515,0,0,1,.516.515v.468a.516.516,0,0,1-.516.516",
    fill: "#040405"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_8746",
    "data-name": "Group 8746",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8745",
    "data-name": "Group 8745"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8744",
    "data-name": "Group 8744",
    clipPath: "url(#clip-path-5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8743",
    "data-name": "Group 8743"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8742",
    "data-name": "Group 8742",
    clipPath: "url(#clip-path-5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_22876",
    "data-name": "Path 22876",
    d: "M135.686,154.467H120.427a.515.515,0,0,1-.515-.515v-.468a.516.516,0,0,1,.515-.516h15.259a.516.516,0,0,1,.516.516v.468a.515.515,0,0,1-.516.515",
    fill: "#040405"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_8751",
    "data-name": "Group 8751",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8750",
    "data-name": "Group 8750"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8749",
    "data-name": "Group 8749",
    clipPath: "url(#clip-path-7)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8748",
    "data-name": "Group 8748"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8747",
    "data-name": "Group 8747",
    clipPath: "url(#clip-path-8)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_22877",
    "data-name": "Path 22877",
    d: "M135.686,143.776H120.427a.516.516,0,0,1-.515-.516v-.468a.516.516,0,0,1,.515-.516h15.259a.516.516,0,0,1,.516.516v.468a.516.516,0,0,1-.516.516",
    fill: "#040405"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_8756",
    "data-name": "Group 8756",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8755",
    "data-name": "Group 8755"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8754",
    "data-name": "Group 8754",
    clipPath: "url(#clip-path-9)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8753",
    "data-name": "Group 8753"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8752",
    "data-name": "Group 8752",
    clipPath: "url(#clip-path-10)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_22878",
    "data-name": "Path 22878",
    d: "M135.686,133.848H120.427a.515.515,0,0,1-.515-.515v-.468a.516.516,0,0,1,.515-.516h15.259a.516.516,0,0,1,.516.516v.468a.515.515,0,0,1-.516.515",
    fill: "#040405"
  })))))), /*#__PURE__*/React.createElement("path", {
    id: "Path_22879",
    "data-name": "Path 22879",
    d: "M77.76,162.715H55.769V115.424H77.76Zm-21.289-.7H77.056V116.128H56.471Z",
    fill: "#464545"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_8761",
    "data-name": "Group 8761",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8760",
    "data-name": "Group 8760"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8759",
    "data-name": "Group 8759",
    clipPath: "url(#clip-path-11)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8758",
    "data-name": "Group 8758"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8757",
    "data-name": "Group 8757",
    clipPath: "url(#clip-path-12)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_22880",
    "data-name": "Path 22880",
    d: "M74.4,124.621H59.138a.516.516,0,0,1-.515-.516v-.468a.515.515,0,0,1,.515-.515H74.4a.515.515,0,0,1,.516.515v.468a.516.516,0,0,1-.516.516",
    fill: "#040405"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_8766",
    "data-name": "Group 8766",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8765",
    "data-name": "Group 8765"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8764",
    "data-name": "Group 8764",
    clipPath: "url(#clip-path-13)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8763",
    "data-name": "Group 8763"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8762",
    "data-name": "Group 8762",
    clipPath: "url(#clip-path-13)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_22881",
    "data-name": "Path 22881",
    d: "M74.4,154.467H59.138a.515.515,0,0,1-.515-.515v-.469a.516.516,0,0,1,.515-.515H74.4a.516.516,0,0,1,.516.515v.469a.515.515,0,0,1-.516.515",
    fill: "#040405"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_8771",
    "data-name": "Group 8771",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8770",
    "data-name": "Group 8770"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8769",
    "data-name": "Group 8769",
    clipPath: "url(#clip-path-15)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8768",
    "data-name": "Group 8768"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8767",
    "data-name": "Group 8767",
    clipPath: "url(#clip-path-16)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_22882",
    "data-name": "Path 22882",
    d: "M74.4,143.776H59.138a.516.516,0,0,1-.515-.516v-.468a.516.516,0,0,1,.515-.516H74.4a.516.516,0,0,1,.516.516v.468a.516.516,0,0,1-.516.516",
    fill: "#040405"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_8776",
    "data-name": "Group 8776",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8775",
    "data-name": "Group 8775"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8774",
    "data-name": "Group 8774",
    clipPath: "url(#clip-path-17)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8773",
    "data-name": "Group 8773"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8772",
    "data-name": "Group 8772",
    clipPath: "url(#clip-path-18)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_22883",
    "data-name": "Path 22883",
    d: "M74.4,133.848H59.138a.515.515,0,0,1-.515-.515v-.468a.516.516,0,0,1,.515-.516H74.4a.516.516,0,0,1,.516.516v.468a.515.515,0,0,1-.516.515",
    fill: "#040405"
  })))))), /*#__PURE__*/React.createElement("path", {
    id: "Path_22884",
    "data-name": "Path 22884",
    d: "M96.841,193.1a95.584,95.584,0,1,1,95.585-95.584A95.693,95.693,0,0,1,96.841,193.1m0-182.587a87,87,0,1,0,87,87,87.149,87.149,0,0,0-87-87",
    fill: "#002445"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22885",
    "data-name": "Path 22885",
    d: "M97.825,98.858a6.659,6.659,0,0,1-6.652-6.652V60.916a6.652,6.652,0,0,1,13.3,0v31.29a6.659,6.659,0,0,1-6.652,6.652m0-44.174a6.239,6.239,0,0,0-6.232,6.232v31.29a6.231,6.231,0,1,0,12.463,0V60.916a6.238,6.238,0,0,0-6.231-6.232",
    fill: "#040405"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22886",
    "data-name": "Path 22886",
    d: "M97.825,99.092a6.894,6.894,0,0,1-6.887-6.885V60.917a6.887,6.887,0,1,1,13.774,0v31.29a6.894,6.894,0,0,1-6.887,6.885m0-44.173a6,6,0,0,0-6,6v31.29a6,6,0,0,0,11.995,0V60.917a6,6,0,0,0-6-6",
    fill: "#464545"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22887",
    "data-name": "Path 22887",
    d: "M77.76,115.425l.567,4.037,11.486,13.546H104.5l11.485-13.546v-6.368Z",
    fill: "#009cdd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22888",
    "data-name": "Path 22888",
    d: "M134.166,115.839H60.652a4.536,4.536,0,0,1-4.532-4.531V39.513a7.131,7.131,0,0,1,7.123-7.123h67.321a8.142,8.142,0,0,1,8.133,8.133v70.785a4.535,4.535,0,0,1-4.531,4.531M63.243,32.894a6.627,6.627,0,0,0-6.619,6.619v71.795a4.032,4.032,0,0,0,4.028,4.027h73.514a4.031,4.031,0,0,0,4.027-4.027V40.523a7.637,7.637,0,0,0-7.629-7.629Z",
    fill: "#040405"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22889",
    "data-name": "Path 22889",
    d: "M134.166,116.309H60.652a5.007,5.007,0,0,1-5-5V39.512a7.6,7.6,0,0,1,7.592-7.59h67.321a8.613,8.613,0,0,1,8.6,8.6v70.784a5.007,5.007,0,0,1-5,5M63.243,33.363a6.156,6.156,0,0,0-6.149,6.149v71.795a3.561,3.561,0,0,0,3.558,3.559h73.514a3.562,3.562,0,0,0,3.558-3.559V40.523a7.168,7.168,0,0,0-7.16-7.16Z",
    fill: "#464545"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22890",
    "data-name": "Path 22890",
    d: "M102.4,133.421H97.264v-.364H102.4a2.131,2.131,0,0,0,1.513-.635l10.966-11.15a3.854,3.854,0,0,0,1.113-2.719v-1.721a1.423,1.423,0,0,1,1.421-1.421h.862v.364h-.862a1.059,1.059,0,0,0-1.057,1.057v1.721a4.217,4.217,0,0,1-1.218,2.974l-10.966,11.151a2.5,2.5,0,0,1-1.772.743",
    fill: "#040405"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22891",
    "data-name": "Path 22891",
    d: "M102.4,133.89h-5.6v-1.3h5.6a1.665,1.665,0,0,0,1.179-.494l10.966-11.151a3.391,3.391,0,0,0,.978-2.39v-1.721a1.891,1.891,0,0,1,1.89-1.889h1.331v1.3h-1.331a.588.588,0,0,0-.588.587v1.721a4.678,4.678,0,0,1-1.352,3.3L104.5,133.007a2.971,2.971,0,0,1-2.107.883",
    fill: "#464545"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22892",
    "data-name": "Path 22892",
    d: "M97.265,133.421H91.919a2.506,2.506,0,0,1-1.773-.743L79.181,121.527a4.217,4.217,0,0,1-1.218-2.974v-1.721a1.058,1.058,0,0,0-1.056-1.057h-.862v-.364h.862a1.423,1.423,0,0,1,1.42,1.421v1.721a3.858,3.858,0,0,0,1.113,2.719l10.967,11.15a2.127,2.127,0,0,0,1.512.635h5.346Z",
    fill: "#040405"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22893",
    "data-name": "Path 22893",
    d: "M97.733,133.89H91.919a2.971,2.971,0,0,1-2.107-.883L78.846,121.856a4.678,4.678,0,0,1-1.352-3.3v-1.721a.589.589,0,0,0-.588-.587h-1.33v-1.3h1.33a1.891,1.891,0,0,1,1.89,1.889v1.721a3.387,3.387,0,0,0,.978,2.39L90.74,132.094a1.665,1.665,0,0,0,1.179.494h5.814Z",
    fill: "#464545"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6739",
    "data-name": "Rectangle 6739",
    width: 37.661,
    height: 0.328,
    transform: "translate(78.327 119.133)",
    fill: "#464545"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22894",
    "data-name": "Path 22894",
    d: "M90.494,120.946a1.856,1.856,0,0,1,.432-.53,1.9,1.9,0,0,1,2.677.212l3.517,4.12,4.123-3.517a1.9,1.9,0,0,1,2.464,2.889L96.7,130.1l-5.982-7.01a1.9,1.9,0,0,1-.22-2.146",
    fill: "#f27d11"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1999",
    "data-name": "Line 1999",
    x1: 0.027,
    y2: 22.558,
    transform: "translate(97.303 102.516)",
    fill: "none",
    stroke: "#f27d11",
    strokeLinecap: "round",
    strokeWidth: 1.698
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_188",
    "data-name": "Ellipse 188",
    cx: 20.874,
    cy: 20.874,
    r: 20.874,
    transform: "translate(76.443 132.813)",
    fill: "none",
    stroke: "#f27d11",
    strokeLinecap: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22895",
    "data-name": "Path 22895",
    d: "M192.027,30.167a29,29,0,1,1-29-29,29,29,0,0,1,29,29",
    fill: "#008bc9",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22896",
    "data-name": "Path 22896",
    d: "M157.4,24.307c-.264-3.3-.524-6.531-.775-9.768-.084-1.076-.691-1.728-1.614-1.689-.973.043-1.472.662-1.438,1.79.1,3.352.2,6.708.323,10.062.025.6-.138.97-.792,1.1-.38-1.989-.732-3.933-1.127-5.872a1.4,1.4,0,0,0-1.637-1.069,1.334,1.334,0,0,0-1.053,1.561c.156,1.123.361,2.236.508,3.361.3,2.321.62,4.645.844,6.973.24,2.462.352,4.942,1.692,7.143a3.927,3.927,0,0,1,.347,1.024,26.166,26.166,0,0,1,.414,7.24,1.924,1.924,0,0,0,1.1,1.911,11.515,11.515,0,0,0,5.4,1.445,9.705,9.705,0,0,0,5.516-1.2,1.134,1.134,0,0,0,.63-1.125c-.038-1.083.021-2.167-.016-3.251a5.487,5.487,0,0,1,1.711-4.168c.52-.533,1.152-.961,1.667-1.5,1.014-1.054,2.051-2.1,2.96-3.241,1.493-1.873,2.879-3.832,4.338-5.728.711-.927.421-2.074-.739-2.242a3.986,3.986,0,0,0-2.212.377,32.735,32.735,0,0,0-3.415,2.108c-.951.633-1.679.521-2.093-.541a5.7,5.7,0,0,1-.463-2.469c.32-3.354.752-6.7,1.181-10.052.154-1.222-.261-2.052-1.284-2.265a1.769,1.769,0,0,0-2.078,1.557c-.544,2.877-1.224,5.728-1.851,8.6-.678.1-1.009-.078-1-.793.041-3.635.055-7.28.079-10.92a1.665,1.665,0,1,0-3.318-.217q-.348,5.367-.639,10.738c-.057,1.037-.027,1.037-1.161,1.116",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22897",
    "data-name": "Path 22897",
    d: "M99.016,140.4l-.393-2.615-3.173-.054-.144.975-.249,1.694Z",
    fill: "none",
    stroke: "#464545",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22898",
    "data-name": "Path 22898",
    d: "M99.048,140.4l-.392-2.615-3.173-.054-.144.975L95.09,140.4Z",
    fill: "#33b2ea"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2000",
    "data-name": "Line 2000",
    x1: 3.427,
    transform: "translate(95.305 138.519)",
    fill: "none",
    stroke: "#464545",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22899",
    "data-name": "Path 22899",
    d: "M100.3,145.426a3.23,3.23,0,1,1-3.229-3.23,3.23,3.23,0,0,1,3.229,3.23",
    fill: "#33b2ea"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22900",
    "data-name": "Path 22900",
    d: "M97.09,144.3l-12.538,7.591c-.007,0-2.539,1.093-2.2,1.433.294.3.709,1.952,2.746,1.021.014.015.026.031.039.045.065.069.135.134.2.2-.256.365-.427.774-.2,1.056.365.454.809.536,1.494.142.055.046.107.1.164.143.076.06.155.118.232.177a1.14,1.14,0,0,0-.186.533c.035.52.391.6,1.2.191.112.073.225.143.34.214-.472,1.025-.839,2.872,3.529,1.606,0,0,2.907,2.862,4.951.692,0,0,7.658,2.339,7.263-1.978,0,0,2.314,2.112,2.006-1.344,0,0,2.428.524,1.8-1.655,0,0,6.625-.6,2.119-2.9a139.3,139.3,0,0,1-12.807-7.081c.769.723,3.952,3.989,7.456,7.169m-2.2.037-1.455.023c-.624-.819-1.231-1.721-1.733-2.438,0,0,1.792,1.222,3.188,2.415m-3.8-.685c.129.254.264.5.4.74-.135-.241-.27-.486-.4-.74",
    fill: "#33b2ea"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22901",
    "data-name": "Path 22901",
    d: "M97.234,144.39c2.645,3.653,7.978,13.382,10.469,11.752S97.234,144.39,97.234,144.39",
    fill: "#33b2ea"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22902",
    "data-name": "Path 22902",
    d: "M97.234,144.39c2.645,3.653,7.978,13.382,10.469,11.752S97.234,144.39,97.234,144.39Z",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.042
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22903",
    "data-name": "Path 22903",
    d: "M97.234,144.39c-.285,4.893-1.372,17.737,4.862,15.967s-4.862-15.967-4.862-15.967",
    fill: "#33b2ea"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22904",
    "data-name": "Path 22904",
    d: "M97.234,144.39c-.285,4.893-1.372,17.737,4.862,15.967S97.234,144.39,97.234,144.39Z",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.042
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22905",
    "data-name": "Path 22905",
    d: "M97.016,145.226c-3.314,3.4-12.2,12.112-7.582,14.841s7.582-14.841,7.582-14.841",
    fill: "#33b2ea"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22906",
    "data-name": "Path 22906",
    d: "M97.016,145.226c-3.314,3.4-12.2,12.112-7.582,14.841S97.016,145.226,97.016,145.226Z",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.042
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22907",
    "data-name": "Path 22907",
    d: "M97.091,144.3c-1.528,3.5-6.894,15.7-2.645,16.446S97.091,144.3,97.091,144.3",
    fill: "#33b2ea"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22908",
    "data-name": "Path 22908",
    d: "M97.091,144.3c-1.528,3.5-6.894,15.7-2.645,16.446S97.091,144.3,97.091,144.3Z",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.042
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22909",
    "data-name": "Path 22909",
    d: "M93.707,153.409c-.669,1.534-3.02,6.88-1.158,7.206s1.158-7.206,1.158-7.206",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22910",
    "data-name": "Path 22910",
    d: "M93.707,153.409c-.669,1.534-3.02,6.88-1.158,7.206S93.707,153.409,93.707,153.409Z",
    fill: "none",
    stroke: "#33b2ea",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.019
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22911",
    "data-name": "Path 22911",
    d: "M97.234,144.39c-3.652,2.644-13.652,9.125-12.021,11.615S97.234,144.39,97.234,144.39",
    fill: "#33b2ea"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22912",
    "data-name": "Path 22912",
    d: "M97.234,144.39c-3.652,2.644-13.652,9.125-12.021,11.615S97.234,144.39,97.234,144.39Z",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.042
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22913",
    "data-name": "Path 22913",
    d: "M97.234,144.39c-3.394,2.877-11.2,10.728-10.35,12.523s10.35-12.523,10.35-12.523",
    fill: "#33b2ea"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22914",
    "data-name": "Path 22914",
    d: "M97.234,144.39c-3.394,2.877-11.2,10.728-10.35,12.523S97.234,144.39,97.234,144.39Z",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.042
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22915",
    "data-name": "Path 22915",
    d: "M97.234,144.188c3.937,3.6,11.115,11.929,13.615,9.446s-13.615-9.446-13.615-9.446",
    fill: "#33b2ea"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22916",
    "data-name": "Path 22916",
    d: "M97.234,144.188c3.937,3.6,11.115,11.929,13.615,9.446S97.234,144.188,97.234,144.188Z",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.042
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22917",
    "data-name": "Path 22917",
    d: "M97.083,144.188c-4.955,1.988-15.813,6.978-14.655,10.306s14.655-10.306,14.655-10.306",
    fill: "#33b2ea"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22918",
    "data-name": "Path 22918",
    d: "M97.083,144.188c-4.955,1.988-15.813,6.978-14.655,10.306S97.083,144.188,97.083,144.188Z",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.042
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22919",
    "data-name": "Path 22919",
    d: "M105.967,158.176c1.561-.528-6.373-10.245-6.373-10.245,1.285,2.62,4.813,10.777,6.373,10.245",
    fill: "#33b2ea"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22920",
    "data-name": "Path 22920",
    d: "M105.967,158.176c1.561-.528-6.373-10.245-6.373-10.245C100.879,150.551,104.407,158.708,105.967,158.176Z",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.187
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22921",
    "data-name": "Path 22921",
    d: "M96.982,158.144c1.829.521.252-13.754.252-13.754-.4,3.294-2.079,13.234-.252,13.754",
    fill: "#33b2ea"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22922",
    "data-name": "Path 22922",
    d: "M96.982,158.144c1.829.521.252-13.754.252-13.754C96.839,147.684,95.155,157.624,96.982,158.144Z",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.214
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22923",
    "data-name": "Path 22923",
    d: "M91.9,160.121c1.353.843,1.7-4.294,1.7-4.294-1.092,1.336-3.052,3.45-1.7,4.294",
    fill: "#33b2ea"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22924",
    "data-name": "Path 22924",
    d: "M91.9,160.121c1.353.843,1.7-4.294,1.7-4.294C92.51,157.163,90.55,159.277,91.9,160.121Z",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.187
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22925",
    "data-name": "Path 22925",
    d: "M101.988,152.716c1.032,2.212,2.594,5.917,3.88,5.529s-3.88-5.529-3.88-5.529",
    fill: "#33b2ea"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22926",
    "data-name": "Path 22926",
    d: "M101.988,152.716c1.032,2.212,2.594,5.917,3.88,5.529S101.988,152.716,101.988,152.716Z",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.042
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22927",
    "data-name": "Path 22927",
    d: "M111.854,148.715c.527-1.042-5.641-.894-5.641-.894,1.951.686,5.118,1.936,5.641.894",
    fill: "#33b2ea"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22928",
    "data-name": "Path 22928",
    d: "M111.854,148.715c.527-1.042-5.641-.894-5.641-.894C108.164,148.507,111.331,149.757,111.854,148.715Z",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.132
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22929",
    "data-name": "Path 22929",
    d: "M107.133,147.931c1.62.6,4.25,1.7,4.706.868s-4.706-.868-4.706-.868",
    fill: "#33b2ea"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22930",
    "data-name": "Path 22930",
    d: "M107.133,147.931c1.62.6,4.25,1.7,4.706.868S107.133,147.931,107.133,147.931Z",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.03
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22931",
    "data-name": "Path 22931",
    d: "M92.068,148.547c.429,1.086,4.417-3.622,4.417-3.622-1.808,1-4.848,2.538-4.417,3.622",
    fill: "#33b2ea"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22932",
    "data-name": "Path 22932",
    d: "M92.068,148.547c.429,1.086,4.417-3.622,4.417-3.622C94.677,145.927,91.637,147.463,92.068,148.547Z",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.132
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22933",
    "data-name": "Path 22933",
    d: "M85.455,149.613c-1.668.458-4.442,1.1-4.324,2.05s4.324-2.05,4.324-2.05",
    fill: "#33b2ea"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22934",
    "data-name": "Path 22934",
    d: "M85.455,149.613c-1.668.458-4.442,1.1-4.324,2.05S85.455,149.613,85.455,149.613Z",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.03
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22935",
    "data-name": "Path 22935",
    d: "M93.482,155.912c-.927,1.316-2.586,3.413-1.479,4.1s1.479-4.1,1.479-4.1",
    fill: "#33b2ea"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22936",
    "data-name": "Path 22936",
    d: "M93.482,155.912c-.927,1.316-2.586,3.413-1.479,4.1S93.482,155.912,93.482,155.912Z",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.042
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22937",
    "data-name": "Path 22937",
    d: "M97.234,144.3a10.914,10.914,0,0,1-.949,2.5c-.307.619-.666,1.289-1.072,1.955-1.006,1.658-2.908,4.6-4.378,5.332-3.55,1.777-.257-2.826,1.842-3.739",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.122
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22938",
    "data-name": "Path 22938",
    d: "M82.7,154.884s10.32-5.15,14.388-10.585",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.122
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMatenimiento2);
export default __webpack_public_path__ + "static/media/matenimiento_2.a6810bb02f23f203811c9a834b37a728.svg";
export { ForwardRef as ReactComponent };